import script from "./CreateQueueButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateQueueButton.vue?vue&type=script&setup=true&lang=js"

import "./CreateQueueButton.vue?vue&type=style&index=0&id=ade4d7fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ade4d7fa"]])

export default __exports__